import { useMemo, useState } from 'react';
import { Resources } from '@shared/localizations/Resources';
import { sortColumnsBySortingInfo } from '@shared/utils/Table/TableColumnSorting';
function createVisibilityContextMenuItems(columns, visibleColumns, toggleColumnVisibility) {
    var _a, _b, _c;
    const sortedColumns = sortColumnsBySortingInfo(columns);
    const menuItems = [];
    for (let i = 0; i < sortedColumns.length; i++) {
        const column = sortedColumns[i];
        const prevColumn = i > 0 ? sortedColumns[i - 1] : null;
        const menuItem = {
            type: 'item',
            id: column.id,
            text: Resources.getResource(column.localizationKey),
            checked: visibleColumns.some((c) => c.id === column.id),
            onClick: () => toggleColumnVisibility(column)
        };
        if (prevColumn !== null &&
            ((_a = prevColumn.sortingInfo) === null || _a === void 0 ? void 0 : _a.groupIndex) !== ((_b = column.sortingInfo) === null || _b === void 0 ? void 0 : _b.groupIndex) &&
            isValidNumber((_c = column.sortingInfo) === null || _c === void 0 ? void 0 : _c.groupIndex)) {
            menuItems.push({
                type: 'separator',
                id: 'separator-' + prevColumn.sortingInfo.groupIndex
            });
        }
        menuItems.push(menuItem);
    }
    return menuItems;
}
function createHeaderContextMenuItems(columns, visibleColumns, toggleColumnVisibility, resetToDefaultVisibility, hideContextMenu) {
    const visibilityItems = createVisibilityContextMenuItems(columns, visibleColumns, toggleColumnVisibility);
    const visibilitySeparatorItem = {
        type: 'separator',
        id: 'visibility-separator'
    };
    const visibilityResetItem = {
        type: 'item',
        id: 'visibility-reset',
        text: Resources.getResource('panel.menu.resetToDefault'),
        onClick: () => {
            resetToDefaultVisibility();
            hideContextMenu();
        }
    };
    return [...visibilityItems, visibilitySeparatorItem, visibilityResetItem];
}
export function useTableHeaderContextMenu(columns, visibleColumns, toggleColumnVisibility, resetToDefaultVisibility) {
    const [isShowContextMenu, setIsShowContextMenu] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const onContextMenuShow = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPosition({ x: event.clientX, y: event.clientY });
        setIsShowContextMenu(true);
    };
    const onContextMenuClose = () => {
        setIsShowContextMenu(false);
    };
    const items = useMemo(() => createHeaderContextMenuItems(columns, visibleColumns, toggleColumnVisibility, resetToDefaultVisibility, onContextMenuClose), [columns, visibleColumns]);
    return {
        isShowContextMenu,
        position,
        items,
        onContextMenuShow,
        onContextMenuClose
    };
}
